<nz-select nzShowSearch *ngIf="DO && DO.length > 1" class="quest-input-width d-b" nzPlaceHolder="Choose"
  (ngModelChange)="findProposal/PolicyByNum($event)" [(ngModel)]="selectPolNum">
  <nz-option *ngFor="let item of DO" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum"></nz-option>
</nz-select>
<br>

<div class="title-emphasis">
  <span nz-icon nzType="file-protect" nzTheme="outline" class="title-ico"></span>
  <div>
    <h4 class="p-0 m-0">{{selectedpolicy?.proposalDO?.baseProductCd || '' | technicalTranslate}}</h4>
    <span class="col-grey-dark"
      *ngIf="selectedpolicy?.proposalDO?.proposalNum">{{selectedpolicy?.proposalDO?.proposalNum || '' | translate}}</span>
    <span class="col-grey-dark"
      *ngIf="selectedpolicy?.proposalDO?.proposalNum == null">{{selectedpolicy?.proposalDO?.proposalNum || '' | translate}}</span>
  </div>
</div>

<!-- Summary -->
<div class="summary-container grid grid-3x grid-gap-20">
  <div>
    <span class="s-c-head" translate>Proposal/Policy No</span>
    <span *ngIf="selectedpolicy?.proposalDO?.proposalNum">{{selectedpolicy?.proposalDO?.proposalNum || '' | translate}}</span>
    <span
      *ngIf="selectedpolicy?.proposalDO?.proposalNum ==null">{{selectedpolicy?.proposalDO?.proposalNum || '' | translate}}</span>
  </div>
  <div>
    <span class="s-c-head" translate>Plan Option</span>
    <span>{{(selectedpolicy?.proposalDO?.productPlanOptionCd | technicalTranslate) || '-'}}</span>
  </div>
  <div>
    <span class="s-c-head" translate>Policy Type</span>
    <span>{{(selectedpolicy?.proposalDO?.baseProductTypeCd | technicalTranslate) || '-'}}</span>
  </div>
  <!-- Commented for metlife -->
  <!-- <div>
    <span class="s-c-head" translate>Product</span> {{selectedpolicy?.proposalDO?.baseProductCd || '' | translate}}
    <span *ngIf="selectedpolicy?.proposalDO?.baseProductCd ==null">-</span>
  </div>
  <div>
    <span class="s-c-head" translate>Plan</span> {{selectedpolicy?.proposalDO?.baseProductTypeCd || '' | translate}}
    <span *ngIf="selectedpolicy?.proposalDO?.baseProductTypeCd ==null">-</span>
  </div> -->

  <div>
    <span class="s-c-head" translate>Premium Status</span>
    <span *ngIf="selectedpolicy?.proposalDO?.premiumStatusCd">
      {{ commonUtilty.NVL(selectedpolicy?.proposalDO?.premiumStatusCd) | technicalTranslate }}</span>
    <span *ngIf="selectedpolicy?.proposalDO?.premiumStatusCd ==null">-</span>
  </div>
  <div>
    <span class="s-c-head" translate>Risk Commencement Date</span>
    <nz-badge class="d-b">{{commonUtilty.serverDOtoUIDODate(selectedpolicy?.proposalDO?.policyCommencementDt) |  date: "dd MMM yyyy" }}</nz-badge>
  </div>
  <div>
    <span class="s-c-head" translate>Proposal/Policy Maturity Date</span>
    <nz-badge nzStatus="success">{{commonUtilty.serverDOtoUIDODate(selectedpolicy?.proposalDO?.policyExpiryDt) |  date: "dd MMM yyyy" }} </nz-badge>
    <!-- <small class="d-b">(in 6 months)</small> -->
  </div>

  <div>
    <span class="s-c-head" translate>Issuance Date</span>
    <nz-badge *ngIf="selectedpolicy?.proposalDO?.policyIssueDt!=null">
      {{commonUtilty.serverDOtoUIDODate(selectedpolicy?.proposalDO?.policyIssueDt) |  date: "dd MMM yyyy" }} </nz-badge>
    <nz-badge *ngIf="selectedpolicy?.proposalDO?.policyIssueDt==null">
      {{commonUtilty.serverDOtoUIDODate(selectedpolicy?.proposalDO?.policyCommencementDt) |  date: "dd MMM yyyy" }} </nz-badge>
  </div>

  <!-- Below fields values are not binded -->
  <!-- <div>
    <span class="s-c-head" translate>Premium Paid Till Date</span>
    <span>{{getDateString(selectedpolicy?.proposalDO?.premPaidTillDt)}}</span>
  </div> -->

  <div>
    <span class="s-c-head" translate>Base Premium</span>
    <span>{{(selectedpolicy?.proposalDO?.baseAnnualPremiumAmt  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) || ''}}</span>
  </div>

  <div>
    <span class="s-c-head" translate>Premium With Tax</span>
    <span>{{(selectedpolicy?.proposalDO?.finalPremiumAmt  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) || ''}}</span>
  </div>

  <div *ngIf="false">
    <span class="s-c-head" translate>Payment Method</span>
    <span>{{(selectedpolicy?.proposalDO?.proposalPayments[0]?.paymentMethodCd | technicalTranslate) || ''}}</span>
  </div>

  <div>
    <span class="s-c-head" translate>Premium Frequency</span>
    <span>{{(selectedpolicy?.proposalDO?.paymentFrequencyCd | technicalTranslate) || ''}}</span>
  </div>

  <!-- TODO: Field Not found in ODS -->
  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Sum Insured At Inception</span>
    <span>NOT FOUND ODS</span>
  </div>

  <div>
    <span class="s-c-head" translate>{{appMetadataHandler.SI_LABEL}}</span>
    <span>{{(selectedpolicy?.proposalDO?.sumInsuredAmt  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) || '' }}</span>
  </div>

  <!-- TODO: TO BE changed later -->
  <!-- <div>
    <span class="s-c-head" translate>Premium Paying Term</span>
    <span>{{selectedpolicy?.proposalDO?.indemnityPeriod || ''}}</span>
  </div> -->

  <div>
    <span class="s-c-head" translate>Proposal/Term</span>
    <span>{{selectedpolicy?.proposalDO?.policyTerm || '' }}</span>
  </div>
  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Medical At Proposal</span>
    <span>{{(selectedpolicy?.proposalDO?.medicalStatusCd | technicalTranslate) || ''}}</span>
  </div>

  <!-- <div>
    <span class="s-c-head" translate>UW Loading</span>
    <span>{{selectedpolicy?.proposalDO?.uwDecisionValue || '' | translate}}</span>
  </div> -->

  <!-- <div>
    <span class="s-c-head" translate>Proposal/Policy Status At Event</span>
    <span>{{(selectedpolicy?.proposalDO?.statusCd | technicalTranslate) || ''</span>
  </div> -->

  <!-- TODO: TO be change later -->
  <div>
    <span class="s-c-head" translate>Current Proposal/Policy Status</span>
    <span>{{(selectedpolicy?.proposalDO?.statusCd | technicalTranslate) || ''}}</span>
  </div>


  <!-- <div>
    <span class="s-c-head" translate>Joint Life</span>
    <span *ngIf="selectedpolicy?.proposalDO?.jointLifeFl == 1">Yes</span>
    <span *ngIf="selectedpolicy?.proposalDO?.jointLifeFl != 1">No</span>
  </div> -->

  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Reinstatement Flag</span>
    <span *ngIf="selectedpolicy?.proposalDO?.reinstatementFl == 1">Yes</span>
    <span *ngIf="selectedpolicy?.proposalDO?.reinstatementFl != 1">No</span>
  </div>

  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Reinstatement Date</span>

    <span>{{getDateString(selectedpolicy?.proposalDO?.reinstatementDt)}}</span>
  </div>

  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Claims Propensity Score</span>
    <span>-</span>
  </div>

  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Login Branch</span>
    <span>{{(selectedpolicy?.proposalDO?.agentCompanyBranchCd | technicalTranslate) || ''}} </span>

  </div>

  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>State</span>
    <span>{{(selectedpolicy?.proposalDO?.agentDivisionCd | technicalTranslate) || ''}}</span>
  </div>
  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Sourcing Channel</span>
    <span>{{(selectedpolicy?.proposalDO?.agentSubDivisionCd | technicalTranslate) || ''}}</span>
  </div>

  <!-- <div *ngFor="let item of tempListToshow">
    <span class="s-c-head" translate>{{item?.Key}}</span> {{item?.value}}
    <span *ngIf="item?.value ==null || item?.value== '' ">-</span>
  </div> -->
</div>

<div class="heading-tab" style="margin-top: 15px;">
  <h3 class="heading">
    <i nz-icon nzType="user" class="m-r-5"></i><span>Client Details</span></h3>
</div>
<div>
  <nz-table #smallTable nzSize="small" #clientTable [nzData]="selectedpolicy?.proposalDO?.proposalClients"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th translate>Client Number</th>
        <th translate>Client Name</th>
        <th translate>Role</th>
        <th translate>Age</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of clientTable.data">
        <td>{{getClientNum(data,selectedpolicy?.proposalDO?.proposalNum)}}</td>
        <td><a
            (click)="getClientDOofSelectedClient(data)">{{getClientName(data,selectedpolicy?.proposalDO?.proposalNum)}}</a>
        </td>
        <td>{{(data?.roleCd | technicalTranslate : 'insuredRoleCd') || '-' }}</td>
        <td>{{(data?.entryAge | technicalTranslate) || '-'}}</td>
      </tr>
    </tbody>
  </nz-table>
</div>

<div class="heading-tab" style="margin-top: 15px;">
  <h3 class="heading">
    <i nz-icon nzType="file-search" class="m-r-5"></i><span>Additional Coverages</span></h3>
</div>
<div>
  <nz-table #smallTable nzSize="small" #coverageTable [nzData]="selectedpolicy?.proposalDO?.proposalCoverages || selectedpolicy?.caseDO?.caseCoverages"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th translate>Coverage</th>
        <th translate>{{appMetadataHandler.SI_LABEL}}</th>
        <th translate>Premium</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let data of coverageTable.data">
        <ng-container>
          <tr *ngIf="data?.planTypeCd !='BASEPLAN' &&  data?.associationTypeCd =='MANDATORY'">
            <td>{{(data?.productCd  | technicalTranslate) || ''}} </td>
            <td>{{data?.sumInsuredAmt  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
            <td>{{data?.baseAnnualPremiumAmt  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
          </tr>
        </ng-container>
        <tr *ngIf="data?.planTypeCd !='BASEPLAN' && data?.associationTypeCd =='OPTIONAL'">
          <td>{{(data?.productCd  | technicalTranslate) || ''}} </td>
          <td>{{data?.sumInsuredAmt  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
          <td>{{data?.baseAnnualPremiumAmt  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
</div>

<div *ngIf="selectedpolicy?.proposalDO?.proposalAgents && selectedpolicy?.proposalDO?.proposalAgents.length > 0" class="heading-tab" style="margin-top: 15px;">
  <h3 class="heading">
    <i nz-icon nzType="user" class="m-r-5"></i><span>Intermediary Details</span></h3>
</div>
<div *ngIf="selectedpolicy?.proposalDO?.proposalAgents && selectedpolicy?.proposalDO?.proposalAgents.length > 0">
  <nz-table #agentTable nzSize="small" [nzData]="selectedpolicy?.proposalDO?.proposalAgents"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th translate>Intermediary Code</th>
        <th translate>Intermediary Name</th>
        <th translate>Channel</th>
        <th translate>Commission Percentage</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of agentTable.data">
        <td>{{data?.agentNum}}</td>
        <td>{{getAgentName(data.agentNum)}}</td>
        <td>{{getAgentChannel(data.agentNum) | technicalTranslate}}</td>
        <td>{{data?.commissionPercent || 0}}%</td>
      </tr>
    </tbody>
  </nz-table>
</div>

<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="profilePanelOpen" [nzPlacement]="'right'"
  nzTitle="Client Details" (nzOnClose)="profilePanel(0)">
  <ng-container *nzDrawerContent>
  <ng-container *ngIf="profilePanelOpen">
    <app-view-profile-summary [IO]="selectedClientDO"></app-view-profile-summary>
  </ng-container>
  </ng-container>
</nz-drawer>